import React from 'react';
import journalsList from '../../classes/journalsData';
import conferenecesList from '../../classes/conferencesData';
import workshopsList from '../../classes/workshopsData';
import bookchaptersList from '../../classes/bookchaptersData';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';

export default function Publications() {

    return (
        <div>
            <h1 style={{ textAlign: "left", paddingTop: "2%", paddingLeft: "2%", color: "#286DB5" }}>Publications</h1>
            <br />
            <div className="row">
                <div className="col-sm-10">
                    <Tabs defaultActiveKey="Journal" id="uncontrolled-tab-example" className="mb-3">
                        <Tab eventKey="Journal" title="Journal">
                            <div className="container" style={{ paddingLeft: "7%", paddingRight: "7%" }}>
                                <ol style={{ textAlign: "left", listStyle: "none" }}>
                                    {
                                        journalsList.map(element => {
                                            return (
                                                <li>
                                                    <h4>{element.year}</h4>
                                                    <ol>
                                                        {element.yearWork.map(work => {
                                                            return (
<li>
                                                                    <div className="row" style={{ margin: "1%" }}>
                                                                        <div className="col-lg-10" >
                                                                            <p className="col-12" >{work.data}</p>
                                                                        </div>
                                                                        {
                                                                            work.pdflink !== `` &&
                                                                            <div className="col-lg-2" >
                                                                                <a className="btn btn-primary col-12" style={{ borderRadius: "50pt" }} href={work.pdflink} rel="noreferrer" target="_blank">DOI</a>
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                </li>
                                                            );
                                                        })}
                                                    </ol>
                                                </li>
                                            );
                                        })
                                    }
                                </ol>
                            </div>
                        </Tab>
                        <Tab eventKey="Conference" title="Conference">
                            <div className="container" style={{ paddingLeft: "7%", paddingRight: "7%" }}>
                                <ol style={{ textAlign: "left", listStyle: "none" }}>
                                    {
                                        conferenecesList.map(element => {
                                            return (
                                                <li>
                                                    <h4>{element.year}</h4>
                                                    <ol>
                                                        {element.yearWork.map(work => {
                                                            return (
                                                                <li>
                                                                    <div className="row" style={{ margin: "1%" }}>
                                                                        <div className="col-lg-10" >
                                                                            <p className="col-12" >{work.data}</p>
                                                                        </div>
                                                                        {
                                                                            work.pdflink !== `` &&
                                                                            <div className="col-lg-2" >
                                                                                <a className="btn btn-primary col-12" style={{ borderRadius: "50pt" }} href={work.pdflink} rel="noreferrer" target="_blank">DOI</a>
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                </li>
                                                            );
                                                        })}
                                                    </ol>
                                                </li>
                                            );
                                        })
                                    }
                                </ol>
                            </div>
                        </Tab>
                        <Tab eventKey="Workshop" title="Workshop" >
                            <div className="container" style={{ paddingLeft: "7%", paddingRight: "7%" }}>
                                <ol style={{ textAlign: "left", listStyle: "none" }}>
                                    {
                                        workshopsList.map(element => {
                                            return (
                                                <li>
                                                    <h4>{element.year}</h4>
                                                    <ol>
                                                        {element.yearWork.map(work => {
                                                            return (
                                                                <li>
                                                                    <div className="row" style={{ margin: "1%" }}>
                                                                        <div className="col-lg-10" >
                                                                            <p className="col-12" >{work.data}</p>
                                                                        </div>
                                                                        {
                                                                            work.pdflink !== `` &&
                                                                            <div className="col-lg-2" >
                                                                                <a className="btn btn-primary col-12" style={{ borderRadius: "50pt" }} href={work.pdflink} rel="noreferrer" target="_blank">DOI</a>
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                </li>
                                                            );
                                                        })}
                                                    </ol>
                                                </li>
                                            );
                                        })
                                    }
                                </ol>
                            </div>
                        </Tab>
                        <Tab eventKey="Book Chapter" title="Book Chapter" >
                            <div className="container" style={{ paddingLeft: "7%", paddingRight: "7%" }}>
                                <ol style={{ textAlign: "left", listStyle: "none" }}>
                                    {
                                        bookchaptersList.map(element => {
                                            return (
                                                <li>
                                                    <h4>{element.year}</h4>
                                                    <ol>
                                                        {element.yearWork.map(work => {
                                                            return (
                                                                <li>
                                                                    <div className="row" style={{ margin: "1%" }}>
                                                                        <div className="col-lg-10" >
                                                                            <p className="col-12" >{work.data}</p>
                                                                        </div>
                                                                        {
                                                                            work.pdflink !== `` &&
                                                                            <div className="col-lg-2" >
                                                                                <a className="btn btn-primary col-12" style={{ borderRadius: "50pt" }} href={work.pdflink} rel="noreferrer" target="_blank">DOI</a>
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                </li>
                                                            );
                                                        })}
                                                    </ol>
                                                </li>
                                            );
                                        })
                                    }
                                </ol>
                            </div>
                        </Tab>
                    </Tabs>

                </div>
                <div className="col-sm-2">

                </div>
            </div>

        </div>
    )
}
